var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Customer Visit Plan"}},[_c('div',{staticClass:"vx-row mb-12 col-12"},[_c('div',{staticClass:"vx-col sm:w-1/1 w-full mb-base"},[_c('data-table-sales',{attrs:{"baseUrl":this.baseUrl}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }